<template>
    <div class="px-5px">
        <div class="flex items-center">
            <div>
                <div class="flex justify-center items-center cursor-pointer"
                    @click="toggleCheck()">
                    <!-- <div v-if="check" class="w-4 h-4 bg-tc-blue-1 rounded-full"></div> -->
                    <img class="w-5 h-auto" v-if="check" src="../../../../assets/icon/check_active.png" />
                    <img class="w-5 h-auto" v-else src="../../../../assets/icon/check_inactive.png" />
                </div>
            </div>
            <div class="pl-2">
                <span class="mr-1">{{ lbl.register.form.acceptTerm }}</span>
                <a class="underline text-tc-blue-2 cursor-pointer" @click="getApiUserConsent()">
                    {{ lbl.register.form.acceptTermUrl }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
import UserConsentPDPAModel from '@/core/PDPA/model/UserConsentModel.js';
export default {
    name: 'CheckBoxPdpd',
    mixins: [LocaleMixin],
    props: {
        check: { type: Boolean }, // v-model:check
        controller: Object
    },
    data: function() {
        return {
            termsVersion: null,
            content1: null,
            content2: null
        };
    },
    methods: {
        toggleCheck: function() {
            let value = !this.check;
            this.$emit('update:check', value);
        },
        showPdpdRegisterModal: function(){
            this.controller.pdpaRegisterModal
                .clearModal()
                .setMsg1(this.content1)
                .setMsg2(this.content2)
                .setBtnOk('ปิด')
                .show();
        },
        getApiUserConsent: function () {
            return new Promise((resolve) => {
                this.controller.loadingModal.show();
                BzbsPDPA.apiGetUserConsent()
                    .subscribe({
                        next: (res) => {
                            this.controller.loadingModal.hide();
                            let data = new UserConsentPDPAModel(res.data)
                            if(this.localeCode === 1033){ //en
                                this.content1 = data.content_header_en
                                this.content2 = data.content_purposes_en
                            }else{ //th
                                this.content1 = data.content_header_th
                                this.content2 = data.content_purposes_th
                            }
                            resolve(res);
                            this.showPdpdRegisterModal();
                            resolve(this.consent);
                        },
                        error: (err) => {
                            this.controller.loadingModal.hide();
                            console.log(err);
                            this.controller.alertModal.clearModal().setMsg(err.message).show();
                            resolve(null);
                        }
                    });
            });
        },
        getBzbsTerms: async function() {
            await this.getVersion();
            await this.getContent();

            this.showPdpdRegisterModal();
        },
        getVersion: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion()
                    .subscribe({
                        next: (res) => {
                            console.log('pdpa', res);
                            const result = res.terms.current_version;

                            this.termsVersion = result;
                            resolve(true);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getContent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent('terms', this.termsVersion, this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.content = res;

                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
